module.exports = __webpack_public_path__ + "files/58684a28ed082407e98028f5157649fb.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lato-bolditalic-webfont.svg
 ** module id = 924
 ** module chunks = 0
 **/